import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { FUNNEL_PRODUCTS_PARAMETER_MODULE, DEFAULT_COLUMN } from "../constant/funnelProductsParameterConstant";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setFunnelProductsParameterPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: FUNNEL_PRODUCTS_PARAMETER_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '-created_date',
    });
